import { HttpErrorResponse } from '@angular/common/http';
import { Action, createAction, createActionGroup, props } from '@ngrx/store';
import { CreateAnnotationDto } from '../dtos/create-annotation-dto.interface';
import { GetTaskAnnotationsDto } from '../dtos/get-task-annotations-dto.interface';
import { UpdateAnnotationDto } from '../dtos/update-annotation-dto.interface';
import { Annotation } from '../interfaces/annotation.interface';

export const getTaskAnnotations = createActionGroup({
    source: '[Aumico-Cpmm] Get Task Annotations',
    events: {
        do: props<{ payload: { taskId: string; page: number; limit: number } }>(),
        success: props<{ payload: GetTaskAnnotationsDto }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const setAnnotations = createAction('[Aumico-Cpmm] Set Annotations', props<{ payload: Annotation[] }>());

export const updateAnnotation = createActionGroup({
    source: '[Aumico-Cpmm] Update Annotation',
    events: {
        do: props<{ annotationId: string; payload: UpdateAnnotationDto }>(),
        success: props<{ payload: Annotation }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const deleteAnnotation = createActionGroup({
    source: '[Aumico-Cpmm] Delete Annotation',
    events: {
        do: props<{ payload: string }>(),
        success: props<{ payload: string }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const createAnnotation = createActionGroup({
    source: '[Aumico-Cpmm] Create Annotation',
    events: {
        do: props<{ payload: { taskId: string; payload: CreateAnnotationDto } }>(),
        success: props<{ payload: Annotation }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const setPageNumber = createAction('[Aumico-Cpmm] Set Page Number', props<{ payload: number }>());

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
